import { logout } from "./actions/logout";
import { store } from "./store";
import { lang } from "./lang";

type EndpointError = {
    response?: {
        status?: number;
    };
};

function hasResponseStatus(error: unknown): error is EndpointError {
    return typeof error === "object" && error !== null && "response" in error;
}

function catchEndpoint(e: unknown): void {
    if (!hasResponseStatus(e) || typeof e.response?.status !== "number") return;
    if (e.response.status === 401) {
        // Unauthorized
        logout();

        store.doNotice(lang.unauthorizedError);
    } else if (e.response.status === 502) {
        // Bad Gateway (Django not running)
        store.doNotice(lang.unreachableError);
    } else if (e.response.status === 403) {
        // Bad Gateway (Django not running)
        store.doNotice(lang.forbiddenError);
    } else if (e.response.status === 429) {
        // Bad Gateway (Django not running)
        store.doNotice(lang.tooManyRequestError);
    } else if ([404, 415, 400, 409].includes(e.response.status)) {
        throw e;
    } else {
        // Other (Nginx not running?)
        store.doNotice(lang.unresponsiveError);
    }
}

export { catchEndpoint };
